import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toArray from "@babel/runtime/helpers/toArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toPropertyKey from "@babel/runtime/helpers/toPropertyKey";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { callAllEventHandlers } from "../../assignProps.mjs";
import capitalizeFirstLetter from "../../capitalizeFirstLetter.mjs";
function assign(target, source) {
  return Object.defineProperties(target, Object.keys(source).reduce(function (descriptors, key) {
    descriptors[key] = Object.getOwnPropertyDescriptor(source, key);
    return descriptors;
  }, {}));
}
function defaultProp(prop) {
  return "default".concat(capitalizeFirstLetter(prop));
}
function handlerProp(prop) {
  if (prop === 'value') prop = '';
  if (prop === 'checked') prop = '';
  return "on".concat(capitalizeFirstLetter(prop), "Change");
}
function isControlled(propValue) {
  return propValue !== undefined;
}
function uncontrolledProp(self, propName, propValue, propDefaultValue, propHandler, chainHandler) {
  function getValue() {
    return isControlled(propValue) ? propValue : propName in self.state ? self.state[propName] : propDefaultValue;
  }
  return [getValue(), function (value) {
    var oldValue = getValue();
    if (oldValue === value) return false;
    if (!isControlled(propValue)) self.setState(_defineProperty({}, propName, value));
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return callAllEventHandlers.apply(void 0, [propHandler].concat(_toConsumableArray(chainHandler))).apply(void 0, [value].concat(args));
  }];
}
function uncontrolledUniversal(props, config, uncontrolledProp) {
  var handlerProps = {};
  var uncontrolledProps = Object.keys(config).reduce(function (result, propName) {
    var _objectSpread2;
    var handlerName = handlerProp(propName);
    var defaultPropName = defaultProp(propName);
    var propDefaultValue = result[defaultPropName],
      propValue = result[propName],
      propHandler = result[handlerName],
      other = _objectWithoutProperties(result, [defaultPropName, propName, handlerName].map(_toPropertyKey));
    if (propDefaultValue === undefined) {
      console.warn(defaultPropName, 'must be installed in "defaultProps"');
    }

    // if (typeof propDefaultValue === 'function' && propDefaultValue.defaultInit) {
    //   propDefaultValue = propDefaultValue(result);
    // }

    var setter = config[propName];
    var chainHandler = [];
    if (Array.isArray(setter)) {
      var _setter = setter;
      var _setter2 = _toArray(_setter);
      setter = _setter2[0];
      chainHandler = _setter2.slice(1);
    }
    setter = setter || function (v) {
      return v;
    };
    var _uncontrolledProp = uncontrolledProp(propName, propValue, propDefaultValue, propHandler, chainHandler),
      _uncontrolledProp2 = _slicedToArray(_uncontrolledProp, 2),
      value = _uncontrolledProp2[0],
      handler = _uncontrolledProp2[1];
    // TODO: need to warn about recursion (by lsroman)
    handlerProps[propName] = handler;
    return _objectSpread(_objectSpread({}, other), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, propName, value), _defineProperty(_objectSpread2, handlerName, function (eventOrValue) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      var result = [setter.apply(void 0, [eventOrValue].concat(args))].concat(args);
      if (eventOrValue !== null && eventOrValue !== void 0 && eventOrValue.target) {
        result.push(eventOrValue);
      }
      return handler.apply(void 0, _toConsumableArray(result));
    }), _objectSpread2));
  }, props);
  return [uncontrolledProps, handlerProps];
}
function uncontrolled(self, props, config) {
  return uncontrolledUniversal(props, config, uncontrolledProp.bind(undefined, self));
}
function Enhancement() {
  return {
    condition: function condition(Component) {
      return Boolean(Component.prototype.uncontrolledProps);
    },
    init: function init() {
      this.state = this.state || {};
      assign(this, {
        get handlers() {
          var _uncontrolled = uncontrolled(this, this.props, this.uncontrolledProps()),
            _uncontrolled2 = _slicedToArray(_uncontrolled, 2),
            uncontrolledHandlers = _uncontrolled2[1];
          return uncontrolledHandlers;
        }
      });
    },
    context: function context(_context) {
      return _objectSpread(_objectSpread({}, _context), {}, {
        handlers: this.handlers
      });
    },
    asProps: function asProps(props) {
      // TODO: need to omit unneccessary props (by lsroman)
      var _uncontrolled3 = uncontrolled(this, props, this.uncontrolledProps()),
        _uncontrolled4 = _slicedToArray(_uncontrolled3, 1),
        uncontrolledProps = _uncontrolled4[0];
      return uncontrolledProps;
    }
  };
}
export default Enhancement;
//# sourceMappingURL=uncontrolledProps.mjs.map